import { render, staticRenderFns } from "./dataList.vue?vue&type=template&id=7688c0c0&scoped=true&"
import script from "./dataList.vue?vue&type=script&lang=js&"
export * from "./dataList.vue?vue&type=script&lang=js&"
import style0 from "./dataList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dataList.vue?vue&type=style&index=1&id=7688c0c0&lang=less&scoped=true&"
import style2 from "./dataList.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7688c0c0",
  null
  
)

export default component.exports